<template>
  <v-app>
    <AppBar color="primary100">
      <v-row class="d-flex justify-end">
        <v-col class="d-flex align-center justify-end">
          <Menu />
        </v-col>
      </v-row>
    </AppBar>
    <v-main class="primary100">
      <transition>
        <router-view class="app-width-limit" />
      </transition>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import AppBar from "@/components/AppBar";
import Footer from "@/components/public/Footer";
import Menu from "@/components/Menu";
export default {
  components: {
    AppBar,
    Footer,
    Menu
  },
  data: () => ({
    menu: false,
  })
};
</script>
